import { useEffect } from 'react';
import { useShallow } from 'zustand/shallow';

import { store } from './store';

export const resetOpenCall = () => store.getState().resetOpenCall();

export function useOpenCall(openCallId: string) {
  const { data, error, fetchOpenCall, loading, requestedId } = store(
    useShallow((state) => ({
      data: state.data,
      error: state.error,
      fetchOpenCall: state.fetchOpenCall,
      loading: state.loading,
      requestedId: state.requestedId,
    })),
  );

  useEffect(() => {
    if (
      openCallId &&
      data?.id !== openCallId &&
      requestedId !== openCallId &&
      !loading
    ) {
      fetchOpenCall(openCallId);
    }
  }, [data?.id, fetchOpenCall, loading, openCallId, requestedId]);

  const openCall = data?.id === openCallId ? data : undefined;
  const isLoading = Boolean(
    openCallId &&
      !openCall &&
      (loading || (requestedId !== openCallId && !error)),
  );

  return { openCall, loading: isLoading, error };
}
